import { Col, Row } from "react-bootstrap";
import { AttendancesByCityFilters } from "./AttendancesByCityFilters";
import { AttendancesByCityTable } from "./AttendancesByCityTable";
import { useState } from "react";
import dayjs from "dayjs";
import { User } from "@/@types/sintegrada/User";

export function AttendancesByCity() {
	const [startDate, setStartDate] = useState(dayjs().add(-2, "year").format("YYYY-MM-DD"));
	const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));
	const [youngerAge, setYoungerAge] = useState<number>();
	const [olderAge, setOlderAge] = useState<number>();
	const [professionalId, setProfessionalId] = useState<number>();
	const [professionals, setProfessionals] = useState<User[]>([]);

	console.log(youngerAge + "-" + olderAge);
	console.log(professionalId);
	setProfessionals([]);

	async function fetchDashboard() {}

	return (
		<>
			<Row className="p-2 mb-10">
				<Col>
					<AttendancesByCityFilters
						startDate={startDate}
						setStartDate={setStartDate}
						endDate={endDate}
						setEndDate={setEndDate}
						setYoungerAge={setYoungerAge}
						setOlderAge={setOlderAge}
						setProfessionalId={setProfessionalId}
						professionals={professionals}
						handleFilter={fetchDashboard}
					/>
				</Col>
			</Row>
			<Row className="p-2">
				<Col>
					<AttendancesByCityTable />
				</Col>
			</Row>
		</>
	);
}
